module.exports = __webpack_public_path__ + "images/background/image_thumbnail/6-off-6f5dafff563a2a11a35039221d2cc3a7.jpg";